import { FilterType, ListingPageUrlState, SecondaryProductsIdentifier } from '../../client/redux/products/types';
import { PageType } from '../../client/hooks/UrlManager/types';
import apiRoutes, { ApiRoute } from './apiRoutes';
import { AppliedFilter } from 'Client/components/Generic/FilterAndSortBox/types';

type GetProductPathOptions = Pick<ListingPageUrlState, 'listingPageKey' | 'listingPageType'>;

export const buildApiRouteWithListingPageKey = ({ path, cacheDuration }: ApiRoute, listingPageKey: string) => ({
    path: `${path}/${listingPageKey}`,
    cacheDuration,
});

export const composeGetProductsApiRoute = ({ listingPageKey, listingPageType }: GetProductPathOptions): ApiRoute => {
    const productsApiRoute: { [pageType in PageType]?: ApiRoute } = {
        [PageType.CATEGORY]: buildApiRouteWithListingPageKey(apiRoutes.PRODUCTS_CATEGORY_URL_KEY, listingPageKey),
        [PageType.BRANDS]: buildApiRouteWithListingPageKey(apiRoutes.PRODUCTS_BRAND_NAME, listingPageKey),
        [PageType.LANDING]: buildApiRouteWithListingPageKey(apiRoutes.PRODUCTS_LANDING_URL_KEY, listingPageKey),
        [PageType.ALLPRODUCTS]: apiRoutes.PRODUCTS_TEXT_SEARCH,
        [PageType.NEWPRODUCTS]: apiRoutes.NEW_PRODUCTS,
    };

    return productsApiRoute[listingPageType] || { path: '/products' };
};

export const convertFilters = (filters: AppliedFilter<FilterType>[]) =>
    filters.reduce((filtersObj, filter) => {
        if (filter.values.length === 0) {
            return filtersObj;
        }
        return {
            ...filtersObj,
            [filter.name]: filter.values.join(','),
        };
    }, {});

export const getTypeSpecificQueryParams = (state: ListingPageUrlState): Record<string, any> => {
    if (state.listingPageType === PageType.ALLPRODUCTS) {
        return {
            keyword: state.search,
            strictSearch: state.strictSearch,
        };
    }
    return {};
};

export const getPromotionQueryParams = (state: ListingPageUrlState): Record<string, any> => {
    const pageKey = state.listingPageKey;
    const pagetypeMappings = {
        [PageType.CATEGORY]: { page_type: 'category', page_key: pageKey },
        [PageType.LANDING]: { page_type: 'landing', page_key: pageKey },
        [PageType.LOOKS]: { page_type: 'looksdetailpage' },
        [PageType.NEWPRODUCTS]: { page_type: 'newproduct' },
        [PageType.HOMEPAGE]: { page_type: 'homepagebestsellerslider' },
    };
    const queryParams: Record<string, string> | undefined = pagetypeMappings[state.listingPageType];
    if (!queryParams) {
        return {};
    }
    return queryParams;
};

export const secondaryProductsPathMap = {
    [SecondaryProductsIdentifier.ALL_PRODUCTS]: composeGetProductsApiRoute({
        listingPageType: PageType.ALLPRODUCTS,
        listingPageKey: '',
    }),
    [SecondaryProductsIdentifier.NEW_PRODUCTS]: composeGetProductsApiRoute({
        listingPageType: PageType.NEWPRODUCTS,
        listingPageKey: '',
    }),
};
